import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import viewInviteList from "./components/viewInviteList.vue";
import addInviteItem from "./components/addInviteItem.vue";
import { gmTool, serchSelect } from "@/mixins/index";
import { serverList, vipRechargeUser, vipCall } from "@/api/gmtool/packageCode";
export default {
  name: "communication",
  mixins: [gmTool, serchSelect],
  components: {
    viewInviteList: viewInviteList,
    addInviteItem: addInviteItem
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      exportLoading: false,
      paramsData: {
        page: 1,
        state: '',
        vip_time: ''
      },
      total: 0,
      date: [],
      options: [],
      stateType: [{
        value: 1,
        label: this.$t('recalled')
      }, {
        value: 2,
        label: this.$t('notRecalled')
      }],
      serverLis: []
    };
  },
  created: function created() {
    this.getServer();
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.serverID = '';
      serverList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: ''
      })).then(function (res) {
        if (res.status == 200) {
          _this.serverLis = res.data;
        }
      });
    },
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.paramsData.page = e;
                _this2.paramsData.vip_start_time = _this2.date && _this2.date[0];
                _this2.paramsData.vip_end_time = _this2.date && _this2.date[1];
                _this2.reqLoading = true;
                vipRechargeUser(_objectSpread(_objectSpread({}, _this2.paramsData), {}, {
                  game_id: _this2.rawData.game_id
                })).then(function (res) {
                  if (res.code == 200) {
                    _this2.tableData = res.data.data;

                    _this2.tableData.forEach(function (item) {
                      item.total_amount = _this2.$utils.conversion(item.total_amount).toFixed(3);

                      var foundData = _this2.serverLis.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });

                    _this2.total = res.data.total;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    addInviteItemData: function addInviteItemData(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmInvite'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.addInviteItem.init(row);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    vipCallBack: function vipCallBack(row) {
      var _this4 = this;

      this.$confirm(this.$t('confirmOperation'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var vip_state, user_id_str, role_id, server_id, params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                vip_state = row.vip_state, user_id_str = row.user_id_str, role_id = row.role_id, server_id = row.server_id;
                params = {
                  state: vip_state == 2 ? 1 : 2,
                  user_id: user_id_str,
                  role_id: role_id,
                  server_id: server_id,
                  game_id: _this4.rawData.game_id
                };
                vipCall(params).then(function (res) {
                  if (res.code == 200) {
                    _this4.getList(_this4.paramsData.page);
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.options = val;
    },
    batchInvite: function batchInvite() {
      this.$refs.addInviteItem.init(this.options);
    },
    exportdata: function exportdata() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.exportLoading = true;
                _context5.next = 3;
                return vipRechargeUser(_objectSpread(_objectSpread({}, _this5.paramsData), {}, {
                  page_size: -1,
                  game_id: _this5.rawData.game_id
                })).then(function (res) {
                  if (res.code == 200) {
                    var list = res.data.data;
                    list.forEach(function (item) {
                      item.total_amount = _this5.$utils.conversion(item.total_amount).toFixed(3);

                      var foundData = _this5.serverLis.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });
                    var columns = [{
                      label: _this5.$t('game'),
                      prop: 'game'
                    },, {
                      label: _this5.$t('channel'),
                      prop: 'channel'
                    }, {
                      label: _this5.$t('pkg'),
                      prop: 'pkg'
                    }, {
                      label: _this5.$t('adChannel'),
                      prop: 'ad_channel'
                    }, {
                      label: _this5.$t('adPlacement'),
                      prop: 'ad_placement'
                    }, {
                      label: _this5.$t('serverName'),
                      prop: 'server_name'
                    }, {
                      label: _this5.$t('userId'),
                      prop: 'user_id_str'
                    }, {
                      label: _this5.$t('roleId'),
                      prop: 'role_id'
                    }, {
                      label: _this5.$t('roleName'),
                      prop: 'role_name'
                    }, {
                      label: _this5.$t('phoneNumber'),
                      prop: 'phone'
                    }, {
                      label: _this5.$t('totalCumulativeRechargeAmount'),
                      prop: 'total_amount'
                    }, {
                      label: _this5.$t('lastLoginTime'),
                      prop: 'last_login_time'
                    }, {
                      label: _this5.$t('lastRechargeTime'),
                      prop: 'last_recharge_time'
                    }, {
                      label: _this5.$t('lastInviteTime'),
                      prop: 'last_send_time'
                    }, {
                      label: _this5.$t('isLost'),
                      prop: 'loss'
                    }];

                    _this5.$export.excel({
                      columns: columns,
                      data: list,
                      title: _this5.$route.meta.title
                    });
                  }
                }).finally(function () {
                  _this5.exportLoading = false;
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};